import React from 'react';
import { Button, Toggle } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';

interface CustomToggleProps {
  value: string;
  onChange: any;
}

const CustomToggle = ({ value, onChange }: CustomToggleProps) => (
  <Toggle onChange={onChange}>
    <Button active={value === Sens.DEPENSE}>Dépense</Button>
    <Button active={value === Sens.RECETTE}>Recette</Button>
  </Toggle>
);

export default CustomToggle;
